import Commons from "oc-commons/Commons";
import Scenes from "oc-threejs/Scenes";
import UniversalLoader from "oc-threejs/loader/UniversalLoader";
import {v3} from "oc-threejs/short3";
import { Vector3 } from "three/build/three";

const BaseType = (superclass = THREE.Object3D) => class extends superclass {

    constructor(vsData) {
        super();
        this.forbidAutoRemove = false;
        this.vsData = vsData;
        this.vsDataOld = {};
        this.castShadow = true;
        this.receiveShadow = true;
        this.vsDataOld = {
            last: {},
            changed: {},
            compilationNumber: 0,
        };
    }

    /**
     * Sinn dieser Methode ist es, in den Typen die Materialien, Geometrien etc. nur bei Bedarf zu ändern.
     * Gibt zurück, ob ein Wert aus vsData sich geändert hat im Vergleich zum letztmaligen compile-Aufruf
     */
    isVsChanged(path,accessor=o=>o[path]) {
        if (this.vsDataOld.compilationNumber !== APP.model.compilationNumber) {
            this.vsDataOld.changed = {};
            this.vsDataOld.compilationNumber = APP.model.compilationNumber;
        }
        const buffered = this.vsDataOld.changed[path];
        if (buffered !== undefined) {
            return buffered;
        }
        const valueOld = this.vsDataOld.last[path];
        const valueNew = accessor(this.vsData);

        const changed = !Commons.isEqualEpsilon(valueOld,valueNew);
        if (changed) {
            this.vsDataOld.last[path] = Commons.cloneDeep(valueNew);
        }
        this.vsDataOld.changed[path] = changed;
        return changed;
    }

    loadTexture(textureUrl) {
        return UniversalLoader.loadTexture(textureUrl, null, () => {
            STAGE.setDirty();
        }, (e) => console.log(e), 'anonymous');
    }

    loadOBJ(options) {

        options = Commons.defaultsDeepSafe({}, options, {
            path: null,
            baseScale: 100,
            parent: this,
            showDummy: true,
            callback: (object3d) => {
            },
        });

        let path = options.path;
        const product = APP.findProduct(options.artikelnummer);
        if (path == null) {
            if (product == null) {
                throw 'unknown product ' + options.artikelnummer;
            }
            path = product.objName;
        }
        const baseUrl = APP.contentBaseUrl;
        let fullPath = baseUrl + path;
        if (path.endsWith(".mtl")){
            fullPath=[baseUrl+path, (baseUrl+path).replace(/mtl$/,'obj')];
        }

        let dummyObject = null;
        if (options.showDummy) {
            // dummyObjekt - Workaround: Laden ist asynchron. Wenn das Objekt leer ist - also gar keine Geometrie
            // enthält - dann klappt drag&drop nicht
            dummyObject = Scenes.box(v3(5, 5, 5), {color: 0x808080, transparent: true, opacity: 0.1});
            options.parent.add(dummyObject);
        }
        Scenes.remove(dummyObject);

        const productScale = product.Scale;
        const productRotation = product.Rotation;
        const productPosition = product.Position;

        const scale = productScale ? APP.typeConverter.parse_Vector3(productScale).multiplyScalar(options.baseScale) : null;
        const rotation = productRotation ? APP.typeConverter.parse_Rotation(productRotation) : null;
        const position = productPosition ? APP.typeConverter.parse_Vector3(productPosition).multiplyScalar(options.baseScale) : null;;

        if (!Commons.isEmpty(path)) {
            UniversalLoader.loadModel(fullPath, (object3d) => {
                Scenes.remove(dummyObject);
                scale ? object3d.scale.copy(scale) : object3d.scale.copy(new Vector3(1,1,1).multiplyScalar(options.baseScale));
                if(position) object3d.position.copy(position);
                if(rotation) object3d.quaternion.copy(rotation);
                options.parent.add(object3d);
                options.callback(object3d, {
                    quaternion: rotation ?? null
                });

                _.delay(() => STAGE.dirty(), 50);
                _.delay(() => STAGE.dirty(), 500);
            });
        }
    }

};

export default BaseType;
